
/* START_TEMPLATE */
define('hbs!app/templates/_rows',['hbs','Handlebars','app/templates/_helpers/subview'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var stack1, buffer = "";
  stack1 = helpers.each.call(depth0, (depth0 != null ? depth0.rows : depth0), {"name":"each","hash":{},"fn":this.program(2, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"2":function(depth0,helpers,partials,data) {
  var stack1, helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, buffer = "<div class=\"at-row "
    + escapeExpression(((helper = (helper = helpers.classes || (depth0 != null ? depth0.classes : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"classes","hash":{}}) : helper)))
    + "\">";
  stack1 = helpers.each.call(depth0, depth0, {"name":"each","hash":{},"fn":this.program(3, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</div>";
},"3":function(depth0,helpers,partials,data) {
  var stack1, helperMissing=helpers.helperMissing, buffer = "";
  stack1 = ((helpers.subview || (depth0 && depth0.subview) || helperMissing).call(depth0, depth0, {"name":"subview","hash":{}}));
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"5":function(depth0,helpers,partials,data) {
  var stack1, buffer = "";
  stack1 = helpers.each.call(depth0, (depth0 != null ? depth0.children : depth0), {"name":"each","hash":{},"fn":this.program(6, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"6":function(depth0,helpers,partials,data) {
  var stack1, lambda=this.lambda, escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, buffer = "<div class=\"at-row at-row-full "
    + escapeExpression(lambda((depth0 != null ? depth0.name : depth0), depth0))
    + "\">\n      ";
  stack1 = ((helpers.subview || (depth0 && depth0.subview) || helperMissing).call(depth0, depth0, {"name":"subview","hash":{}}));
  if (stack1 != null) { buffer += stack1; }
  return buffer + "\n    </div>";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, buffer = "";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.rows : depth0), {"name":"if","hash":{},"fn":this.program(1, data),"inverse":this.program(5, data)});
  if (stack1 != null) { buffer += stack1; }
  return buffer;
}});
Handlebars.registerPartial('app/templates/_rows', t);
Handlebars.registerPartial('./_rows', t);
return t;
});
/* END_TEMPLATE */
;
